// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3p6lR","containerItemsCenter":"Skeleton_containerItemsCenter__1j0LC"};